module.exports = {
  "FoodC_edit_stZr_IBeA": "Otro",
  "FoodC_check_HTib_sWqA": "Realizando pedido",
  "FoodB_20250414_cwcj_LKFT": "P2",
  "Gattaran_V1__YaIb": "En línea",
  "Gattaran_V1__xaNO": "Tasa de cancelación",
  "FoodC_edit_AxtX_PAiY": "Ejemplo: 1118, edificio C",
  "FoodB_0926__pZyK": "No hay promociones en curso",
  "FoodB_Show_ID_Card_BrxO": "Cédula de identidad",
  "FoodB_Analysis_Yesterday_nearly_aBCt": "Ayer",
  "FoodB_030_zOTR_tsWu": "Mi zona",
  "FoodC_intostore_Store_Coupon_kHwh": "Cupones de la tienda",
  "FoodB_calculator_ULXU_HjOF": "IVA",
  "FoodB_0617_DewC_iPTt": "Pedidos completados por día con la competencia - R",
  "Gattaran_REGULAR_xhms_NLbn": "Restablecer",
  "FoodB_up20241218_aEPD_NaLf": "Seleccionar artículos",
  "FoodB_calculator_WKKD_DbHM": "Base gravable de pagos en línea",
  "FoodB_Commision_Add_MPEf": "Agregar",
  "FoodC_202408_wten_GUVt": "Selecciona la dirección de entrega",
  "FoodB_calculator_CXvv_RJgQ": "Monto a recibir antes de impuestos y comisión",
  "FoodD_Questionnaire_Finished_YvLk": "Listo",
  "FoodB_030_fqBt_uzDV": "Faltan permisos: {{City}}. Solicita un permiso en Gattaran.",
  "FoodB_tagging_You_chose_OMGB": "Decidiste invalidar este socio potencial por el siguiente motivo: \"La tienda no existe\". Para hacerlo, debes cargar una foto.",
  "FoodB_calculator_gRHL_Sgok": "Margen de utilidad",
  "FoodC_homepage_Enter_delivery_IZAu": "Ingresar dirección de entrega",
  "FoodB_0617_BYzk_fNiR": "Hay un contrato de exclusividad con la competencia - R",
  "FoodB_202311_VkTS_OoIy": "Vencida",
  "Help_V4_Enter_the_xqlm": "Ingresa un número de celular válido.",
  "FoodC_Card2_When_the_sFOa": "Abre a las",
  "FoodB_0_Please_upload_ziBz": "Carga una captura de pantalla del historial de llamadas",
  "FoodB_phrase__NpWx": "Sólo promos finalizadas en los últimos {{number}} meses",
  "soda-c-i18n---早间：%s-%s": "Durante la mañana: %s a %s",
  "FoodD_Orders_Can_not_fkHK": "La hora de inicio no puede ser posterior o igual a la hora de finalización.",
  "FoodD_payout_Company_Registration_zoVW": "Cédula Jurídica",
  "FoodB_202303_YWUL_hwNF": "Aceptar",
  "FoodB_data_Beginning_PbJC": "Hora de inicio",
  "FoodB_audit_Distance_between_BRSw": "Distancia entre la tienda anterior y la nueva",
  "FoodB_0617_pLtb_hIQz": "Pedidos completados por día con la competencia - U",
  "FoodB_0905__dSOH": "Diagnóstico de la tienda",
  "FoodB_Launch_DR_Military_Rxvi": "Cédula Militar",
  "FoodC_orderlist_Completed_Xuod": "Finalizado",
  "FoodB_Contract_UTbX_JhBf": "¿El acuerdo incluye comparación con precios para comer en el lugar?",
  "FoodB_B86_vHgx_eMOl": "Actuales",
  "FoodB_Show_Store_Direct_GuJM": "Contrato firmado mediante B-App",
  "GRider_dlp_Mjnq_pnxH": "Más información",
  "FoodOpB_Management_Appeals_foxk": "Solicitar revisión",
  "FoodB_optimization__bdZL": "La imagen debe tener un formato JPG o PNG, pesar menos de 5 MB y ser de al menos 200×200 píxeles.",
  "FoodC_notice_fOyQ_lqIn": "El pago en efectivo no está disponible. Por favor, revisa si el importe del pedido supera el límite, o si tienes otro pedido con pago en efectivo en curso, e inténtalo de nuevo más tarde.",
  "FoodB_Launch_DR_Foreigner_gXpW": "Cédula Extranjera",
  "FoodB_0617_bADA_vnGU": "Servicio de pedidos autogestionados",
  "FoodC_202408_HkLu_Mwgv": "No hay permisos de ubicación",
  "soda-c-i18n---个人中心的“优惠券”": " Mi Perfil > Cupones.",
  "FoodB_210811_No_tax_QkcN": "Falta un documento fiscal",
  "FoodC_sales_Confirmation_mTGd": "Entendido",
  "FoodC_202408_QAer_OYaB": "¡Te damos la bienvenida!",
  "soda-c-i18n---1、超时赔付服务是%s为您免费提供的服务，当前订单（不含已取消订单）未在预计送达时间内送达，%s将赔付给您一定金额的优惠券，订单完成后可以在中查看。": "1. Como parte de nuestro programa de lealtad queremos darte unos cupones en caso de una entrega con demora. Si un pedido no se entrega en el tiempo de entrega estimado (salvo los pedidos cancelados), %s te dará uno o más cupones gratis. Puedes ver los cupones una vez que se complete el pedido en",
  "FoodC_edit_SkdG_WQKu": "Encontrarse en la recepción del hotel",
  "FoodC_20240607_wfRH_rTAa": "Información de la tienda",
  "FoodB_Contract_Jthe_YSbD": "¿Se actualizó la información de encuesta para la tienda?",
  "FoodB_v1_Sources_of_DsXR": "Fuente de información",
  "FoodC_202412_nXPk_kwtQ": "¿No encuentras la dirección? Prueba otras palabras",
  "FoodB_calculator_HXix_qhAK": "ISR sobre base gravable",
  "FoodC_education_1_Customers_Gpbb": "1. Antes de realizar un pedido, elige la mejor opción de entrega para ti. Indica al socio repartidor cómo prefieres la entrega del  pedido según la opción que selecciones:",
  "FoodC_202408_reKH_lclj": "Agregar dirección de entrega",
  "FoodC_edit_hDGv_arOT": "Encontrarse en la recepción de abajo",
  "FoodD_Name_April_UHuR": "Abr",
  "soda-c-i18n---现金": "Efectivo",
  "FoodB_420241024_mWia_Agjc": "No se logró",
  "FoodC_education__1_mJTG": "(1) Si la tienda ya confirmó y aceptó el pedido, puedes usar la función \"Cancelar pedido\" o contactar a la tienda y pedirle que cancele el pedido. Si la tienda no acepta cancelar el pedido porque ya está listo o por otro motivo razonable, no podrás cancelar el pedido sin costo extra. Si insistes en cancelar o te niegas a recibir una parte del pedido o el pedido completo, se deberán pagar los gastos correspondientes de ese pedido.",
  "FoodC_20240607_STdK_ZTMu": "Servicio técnico proporcionado por {{brand_name}}",
  "FoodB_phrase__PWcd": "No hay promos finalizadas para ver",
  "FoodB_202502_ldlj_sqzT": "Enviar",
  "FoodB_APP_jedo_DJtn": "Situación de la promoción",
  "Gattaran_V1__hUDQ": "Servicio",
  "FoodB_0_Please_upload_BZIQ": "Carga una captura de pantalla del historial de chat",
  "FoodB_Show_Current_NJqK": "Cuenta corriente",
  "soda-c-i18n---将赔付给您1张%s优惠券": "Obtienes un cupón de %s.",
  "FoodB_CL_power_of_KgHH": "Contrato de mandato",
  "FoodC_edit_iuIV_BOva": "10 minutos",
  "FoodC_20240607_Olbe_DAqS": "No se puede cargar",
  "FoodB_20250414_oAyQ_liSz": "Descuento final",
  "FoodB_email_wMIf_SGNM": "Nombre del contacto",
  "FoodB_1__gcdX": "Datos del evento",
  "FoodB_list_KP_Phone_qQCQ": "Teléfono del representante de la tienda",
  "FoodD_payout_Account_Type_YmVW": "Tipo de cuenta",
  "FoodC_replace_Clear_Filter_iwTY": "Borrar filtros",
  "FoodB_030_SQUQ_YDRS": "No mis tiendas",
  "FoodB_Contract_wsvf_fSJn": "Comparación con precios para comer en el lugar en el acuerdo",
  "FoodB_V2_dLkl_pbiF": "Para realizar esta acción, actualiza la aplicación a la versión más reciente.",
  "FoodB_governance_OCvE_wAPt": "Gestionar ahora",
  "FoodB_Translation_JSTh_Vrzb": "Motivo detallado de la apelación",
  "FoodB_model20250116_innF_fIuu": "Visita exitosa",
  "FoodB_email_CBNM_cSdr": "Correo electrónico",
  "FoodB_V2_Illegal_companies_pXwb": "No registrada legalmente",
  "Gattaran_Grocery__pKzk": "Shop",
  "FoodC_202408_ksyj_sXlp": "Acerca de la tienda",
  "FoodC_sidebar_Scan_QR_ONzJ": "Escanea el código QR con la cámara de tu celular",
  "FoodC_sidebar_Use_the_huoZ": "Pide cuando quieras, donde quieras",
  "FoodB_0622_Increase_store_kZfr": "Agregar comparación de tiendas",
  "FoodB_management_Automatic_Switching_ghJS": "Apertura/cierre automático de la tienda",
  "FoodB_calculator_GdDU_bFgc": "Subsidio DiDi",
  "FoodC_education_3_If_wduh": "",
  "FoodC_202412_dCuL_VUFU": "Actual.",
  "FoodOpB_CRM_Party_B_BCQp": "Número de identificación de la empresa",
  "Gattaran_REGULAR_XlOa_yzqB": "Resultado",
  "FoodB_calculator_BKfQ_ehtA": "Comisión DiDi",
  "FoodC_202412_bolI_YXBT": "Direcciones guardadas",
  "FoodD_Name_January_lhYr": "Ene",
  "FoodB_Translation_fqel_jrJX": "Imágenes probatorias (opcional)",
  "FoodB_email_SdUD_YAhg": "Falta información. Por favor, agrégala para enviar el correo electrónico",
  "FoodB_0617_qTmE_PWeM": "¿Cuántos pedidos con retiro en tienda realiza el restaurante por día?",
  "FoodB_communications_nVMa_oikA": "Impulso para tiendas nuevas",
  "FoodB_B86_Bhsy_ekdS": "Gestión de irregularidades",
  "FoodB_email_CuqE_WLmP": "¡Hola! Visitamos tu marca {{brand_name}} y revisamos lo siguiente junto con {{person_to_be_visited}}:",
  "FoodD_Storefront_YFcS_cnUy": "DiDi Negocio",
  "FoodB_audit_Store_Information_ryuV": "Se realizó una revisión de la información modificada de la tienda",
  "FoodC_20240607_Upph_ldoj": "Recordatorio de compra",
  "FoodB_calculator_VKAb_KHst": "Subsidio DiDi",
  "FoodD_Name_May_zYiz": "May",
  "FoodB_list_KP_Name_GQRs": "Nombre del representante de la tienda",
  "FoodC_202410_ZHQi_kNsP": "Editar",
  "FoodC_202412_Oant_EESB": "Siguiente",
  "FoodC_c_Completed_djPp": "Finalizado",
  "FoodB_20250414_hanC_RXkJ": "P1*P2",
  "FoodB_communications_APfO_DcRl": "Acciones no completadas para el impulso de tiendas nuevas",
  "FoodC_edit_JdIz_uKvw": "Encontrarse afuera",
  "FoodB_list_Recently_launched_IWDa": "Última vez conectada",
  "FoodC_education_In_order_SRIb": "Esta política de cancelación se creó para ayudar a que todos los usuarios tengan una buena experiencia con {{brand_name}}.",
  "FoodB_Show_Taxpayer_Document_eadz": "Tipo de documento tributario (local)",
  "FoodB_method_hwZM_aUnb": "Descargar Explorer",
  "FoodB_Contract_CqnW_XWkx": "Premio de tarifa de servicio en el acuerdo",
  "FoodB_management_Automatic_closing_xRSd": "Cierre automático de la tienda",
  "FoodC_202408_qXNe_iBNs": "No se pudo obtener la ubicación actual",
  "FoodB_up20241218_Btbi_AOsy": "Enviado",
  "Gattaran_REGULAR_TWeg_lFbm": "Este campo es obligatorio",
  "FoodC_202408_LBac_RLgP": "Agrega la dirección de entrega para que el socio repartidor pueda entregar el pedido",
  "FoodB_governance_OZDM_JqJt": "Rectificación por comparación de precios con la competencia completada o no",
  "FoodC_202408_RRtT_ZjIG": "Agregar dirección de entrega",
  "FoodC_20240607_hhNB_mCBD": "Número de teléfono celular",
  "FoodB_email_QTTk_ZllR": "Enviar acuerdos a la marca",
  "FoodB_20231012_GZve_uPZM": "Ya se establecieron las reglas de cálculo de la fecha límite para este tipo de tarea. Por favor, no vuelvas a ingresarlas.",
  "FoodB_1__IhgO": "Actualizado el {{time}}",
  "FoodB_0617_EuIs_mugQ": "¿Cuántos pedidos con entrega a domicilio realiza el restaurante por día?",
  "FoodB_diagnosis_Items_qQOR": "artículo(s)",
  "FoodC_202408_BsWi_bWTi": "Editar dirección",
  "FoodC_202408_LtuD_oTxz": "Cancelar",
  "FoodB_V1_hqNE_fQDz": "proyectos",
  "FoodC_sales_If_the_TsPm": "Para ayudarnos a verificar el problema con la tienda y el socio repartidor, por favor dinos si el pedido fue entregado en un empaque resellable o sellado de alguna otra forma (como con grapas).",
  "FoodB_Analysis_Nearly_7_wumh": "Últimos {{day}} días",
  "FoodB_2_During_the_QHhU": "Periodo de registro",
  "FoodC_202408_uMeD_ECQU": "Hubo un error. Inténtalo de nuevo.",
  "FoodB_field_No_need_hToz": "Opcional",
  "FoodB_2__YqWB": "Motivo del rechazo",
  "FoodC_Website_From_shop_Jatv": "Realiza un pedido a [shop name] | DiDi Food",
  "FoodB_APP_rwZD_SFlh": "B2C + P2C burn / GMV",
  "FoodC_edit_Fyzp_tERt": "El usuario repartidor te contactará cuando llegue al punto de entrega y esperará en el lugar acordado por máximo {{time}}. Por favor, ten tu teléfono a la mano.",
  "FoodB_requirement_puhp_VPIQ": "Pedidos no preparados a tiempo",
  "FoodB_SMS__promotion_EKZy": "Promoción de entrega sin costo",
  "FoodC_education__2_uVUK": "(2) La tienda a la que le hiciste el pedido estaba cerrada, un producto estaba agotado, ocurrió un accidente o la tienda o el socio repartidor cancelaron el pedido por otro motivo. En ese caso, recibirás un reembolso completo.",
  "FoodB_20250612_SduQ_XghF": "Debes ingresar entre uno y 10 dígitos",
  "FoodB_V1_VKlO_UPTE": "Descripción del proyecto",
  "FoodB_V1_oOpd_aRtv": "No completada",
  "FoodB_up250108_BLxC_rIzf": "Ver después",
  "FoodB_orders_Select_Store_gtmG": "Seleccionar tiendas",
  "FoodB_audit_Suspected_duplicate_ntLx": "Posible tienda duplicada",
  "FoodB_APP_BKjc_PGqI": "Anuncio de tienda",
  "FoodC_202412_DMKw_kWMA": "Intenta buscar la calle y número",
  "FoodB_0905__zFVs": "Peso total",
  "FoodB_requirement_uBiP_YocR": "Porcentaje de pedidos no preparados a tiempo",
  "FoodB_calculator_CcKA_weRh": "Para propósitos referenciales únicamente: el pago final a las tiendas estará sujeto a deducciones por cancelaciones, temas de posventa y otros motivos.",
  "FoodC_education_Platform_Delivery_MJPQ": "Entrega a través de la plataforma",
  "FoodC_202408_qGSr_IQoW": "Editar",
  "Gattaran_visit_zdKK_wwRk": "Resultados de la visita",
  "FoodC_202408_HNlI_lTpJ": "No se ha agregado propina aún",
  "FoodB_APP_mDID_tHft": "Seleccionar periodo de datos",
  "FoodB_incomplete_hmSA_mNRv": "Marcar como No completado",
  "FoodB_audit_Review_process_vGtV": "proceso de revisión. ¿Estás seguro de que quieres continuar?",
  "FoodC_dish_Look_again_fJrp": "Ahora no",
  "FoodB_Optimization_LfPz_zDPq": "Completar registro",
  "FoodC_20240607_ffiX_wNQG": "WhatsApp",
  "soda-c-i18n---提交申请": "Solicitar cancelación",
  "FoodB_Show_Taxpayer_Document_TFeg": "Tipo de documento tributario (nacional)",
  "FoodC_nonaffiliate_Courier_is_iunG": "El socio repartidor va en camino a la tienda para realizar tu pedido.",
  "FoodB_20250414_dobD_hNij": "Tasa de nuevos usuarios",
  "FoodB_Contract_yBjK_Ngdm": "¿El acuerdo es exclusivo?",
  "FoodC_202408_IBpM_TxlD": "Otro",
  "FoodB_IGV_iopU_urly": "IGV",
  "必选": "No es posible desactivar",
  "FoodB_calculator_vEpj_lLGl": "Descuento total",
  "FoodB_20250612_GGEs_TCgn": "Debes ingresar 10 dígitos",
  "FoodB_0_WhatsApp_dmMD": "WhatsApp",
  "FoodD_Name_October_WGkU": "Oct",
  "FoodC_202412_QJMa_Qkwg": "Ingresa una nueva dirección de entrega para agregarla",
  "FoodC_202408_cjXm_VVcd": "Si sales, no podrás ver tu pedido",
  "Gattaran_visit_hZGE_sfuk": "Retroalimentación general",
  "FoodB_0707_High_prices_fBsL": "Más altos",
  "FoodB_Show_Tax_payment_xfxh": "Forma de pago de impuestos (Nacional)",
  "FoodB_0921__isZD": "Tasa de artículos calificados",
  "FoodB_optimization_Buy_gifts_daUI": "Compra X, llévate Y gratis",
  "确认": "Subir",
  "FoodB_communications_HAnw_bYAw": "tiendas con acciones incompletas",
  "FoodC_education_3_Customers_Zoec": "3. Para que el socio repartidor pueda contactarte si lo necesita, procura tener tu teléfono a la mano durante la entrega.",
  "FoodC_202409_yzRW_xKLM": "Este pedido está cerrado. Para ver los detalles, ingresa el número de teléfono celular del solicitante.",
  "FoodC_update_The_expected_ZzFg": "El tiempo de entrega estimado se basa en el tiempo de entrega más reciente.",
  "FoodC_202412_kamX_bNUi": "Por favor, selecciona una dirección para agregar",
  "FoodC_20240607_fIqe_iMtS": "Aceptar",
  "FoodB_20250414_faVK_FFkd": "Tasa",
  "FoodB_pt1_ofEk_bcpz": "Correo electrónico de la persona de contacto",
  "FoodC_202408_BTvL_umes": "¿Deseas salir?",
  "FoodB_B86_lRNJ_EMZv": "Sí",
  "Gattaran_visit_nNId_fOhX": "La visita del BD fue efectiva",
  "Gattaran_REGULAR_irYR_Bntt": "Si no estás seguro de si tu número de identificación fiscal es válido, cópialo y compruébalo en el sitio web oficial que se indica a continuación:",
  "FoodB_Contract_nsIw_Gfzl": "El precio de {{brand_name}} es {{unit}} {{number}} % del precio de la competencia",
  "FoodB_2_Store_XkLQ": "Tienda",
  "FoodB_Translation_kinT_foeX": "Elige el motivo del estado no resuelto",
  "FoodC_202408_ReqK_LVas": "Confirmar",
  "FoodB_Contract_tvcI_RNvn": "Carga correcta del menú para comer en el lugar aprobado",
  "FoodB_0622_Select_up_QXDl": "Selecciona hasta 2 tiendas",
  "FoodC_revision_Less_meal_pHwq": "Error en pedido",
  "FoodC_web_Application_Progress_UYtG": "Estado de la solicitud",
  "FoodC_edit_NDmM_lEJY": "Encontrarse en la puerta",
  "FoodC_202408_HfXO_xbcw": "Ver",
  "FoodB_model20250116_HPUj_zcce": "No se encontró la ubicación. No es posible marcar la hora de ingreso o salida. Por favor, activa los servicios de ubicación en la configuración del teléfono y permite que la aplicación de BD acceda a ellos.",
  "FoodB_420241024_rQXh_ONDO": "Se logró",
  "FoodB_system_Competition_NFPY": "Competidor",
  "FoodB_tagging_You_chose_aZCG": "Decidiste invalidar este socio potencial por el siguiente motivo: \"Operaciones detenidas\". Para hacerlo, debes estar a menos de {{distance}} de la tienda. Verifícalo e inténtalo de nuevo.",
  "FoodC_education__1_vwgm": "(1) Entregar en la puerta",
  "FoodB_task_HEvc_Emme": "Se ejecutó/ejecutaron {{X}} tarea(s) durante esta visita",
  "FoodB_resivion_Feedback_to_QmQU": "Repórtalo a tu supervisor para que la modifique",
  "FoodB_management_Untied_tYEF": "Desvincular",
  "FoodB_task_BFBu_ONmI": "Tarea no ejecutada",
  "FoodB_0926__Jfhv": "No hay promociones con este estado",
  "Gattaran_visit_kYQA_ZYsK": "El BD maneja bien las objeciones de la tienda",
  "FoodB_communications_UOIk_QdZg": "Realiza las acciones para el impulso de tiendas nuevas para obtener ventajas adicionales. Las acciones vencen en {{task_left_days}} día(s)",
  "FoodC_edit_GeFS_ZPLW": "Dirección y nombre del edificio",
  "FoodB_0617_qpbP_bnWv": "Pedidos completados por día - Entrega de la tienda",
  "FoodC_perception_Tips_hZWk": "Propina",
  "FoodB_0907__jtsj": "No hay datos del diagnóstico",
  "FoodB_B86_AADM_isyE": "Cancelar",
  "FoodC_education__1_qvVC": "(1) No recibiste el pedido a tiempo",
  "FoodB_audit_Similarity_check_cQEP": "Evaluación de similitud",
  "FoodC_method_Wait_keAM": "Esperar",
  "soda-c-i18n---请告诉我们，帮助我们一起改善": "Por favor, envíanos tus comentarios y ayúdanos a mejorar.",
  "FoodB_calculator_RWNx_Xkrf": "Persona física",
  "FoodB_Translation_vZUg_djAJ": "Elige el resultado de la resolución",
  "FoodB_group0901_tZIs_QwiK": "Postulado",
  "FoodC_202408_zoCD_Pszh": "Continuar",
  "FoodC_supplement_Return_wVpv": "Atrás",
  "FoodOpB_CRM_Taxpayer_full_fzhk": "Nombre completo del contribuyente (Nacional)",
  "FoodC_optimization_rmLx_bSmk": "Busca tu dirección de entrega y agrégala",
  "FoodB_CL_Simple_company_JBRG": "Sociedad de sistema simplificado",
  "FoodC_edit_bxpb_udFq": "Ejemplo: Edificio C, Núm. 21, Cl. 185 #45-03, Suba, Bogotá, Cundinamarca, Colombia",
  "FoodB_APP_kvLF_MMXl": "Pedidos completados diariamente",
  "FoodB_IV_Open_shop_xlhI": "Apertura automática de la tienda",
  "Gattaran_visit_xnVQ_bENu": "Objetivos a mejorar",
  "FoodB_calculator_yiXt_NkiM": "Comisión DiDi",
  "FoodB_Show_Foreign_DIMEX_LKxF": "DIMEX",
  "FoodC_education_Meal_picking_ziun": "Recomendaciones para la entrega",
  "FoodB_0905__pNYF": "Los pedidos se superponen. La suma no refleja el total de pedidos completados cada día.",
  "FoodB_20231012_Usvn_HuCU": "La tarea se creó con éxito. Puedes seguir el progreso en el módulo Mis tareas.",
  "FoodB_0622_Store_management_ztNB": "Operaciones de la tienda",
  "FoodC_202408_XlDL_LjiM": "Entendido",
  "FoodB_20250612_WpCB_xKZJ": "Otros",
  "FoodC_revision_Contact_customer_XbFk": "Contáctanos",
  "FoodB_0623_Store_GZFE": "Tienda",
  "Gattaran_V1__zewR": "Menú",
  "FoodC_shop__hSnf": "Queda(n) {{num}}",
  "FoodC_Website_DiDi_FoodDiDi_wtqn": "DiDi Food | DiDi Repartidor. Disfruta tu comida cuando quieras, donde quieras.",
  "FoodOpB_Management_High_similarity_lnFn": "Ya existe una tienda similar",
  "FoodB_Launch_DR_Passport_JChW": "Pasaporte",
  "FoodC_edit_dECN_fkIy": "Encontrarse fuera del edificio de oficinas",
  "FoodB_5_Store_Delivery_PIyN": "Entrega por parte de la tienda",
  "FoodC_202408_tJIe_WbFo": "Cancelar",
  "FoodC_202410_mjfG_DDhf": "Agregar",
  "FoodB_2__CkLu": "La misma ciudad",
  "FoodC_202408_tlOV_uOmJ": "Agrega tu número de celular y obtén promociones en tus pedidos",
  "FoodB_calculator_JGZb_tQiY": "Precio para el usuario",
  "FoodB_field_Do_you_mhOz": "¿Sujeto al pago del IVA local?",
  "FoodB_communications_hhCR_kEAh": "tiendas que tienen acciones a realizar esta semana",
  "FoodB_0905__yxOa": "Sin cambios",
  "FoodC_improvement_Rgol_abYw": "Se envió tu solicitud de cancelación. La tienda la revisará en un plazo de {{XminYs}}. Agradecemos tu paciencia.",
  "FoodB_B86_UdlE_SMWM": "Confirmar",
  "FoodB_resivion_Inaccurate_information_dmRA": "¿Hay alguna información incorrecta?",
  "FoodB_calculator_pEyx_wJvY": "Sí",
  "FoodB_0820__bVDh": "Alta prioridad",
  "FoodB_field_Needs_IbzB": "Obligatorio",
  "FoodC_page__KWIm": "Aceptar",
  "FoodB_B86_bcPL_fkRh": "Anteriores",
  "Gattaran_visit_Wpaf_mvuG": "El BD cerró los acuerdos exitosamente",
  "FoodC_education_5_Cash_zBuY": "5. Si realizas un pedido con pago en efectivo, procura tener suficiente dinero a la mano para pagar el pedido antes de aceptar la entrega.",
  "FoodB_subsidy_tVNZ_GHKr": "Recordatorio",
  "FoodB_0905__Uuug": "Reglas del diagnóstico",
  "FoodB_CL_Traditional_companies_cQhK": "Sociedad de sistema tradicional",
  "Groceries_shop2_Fwyu_yymq": "Sólo se puede agregar hasta {{num}} artículos al carrito.",
  "FoodC_sidebar_Update_successfully_cuyI": "Actualización completada",
  "FoodB_executors20241225_bYiY_UfOD": "Lógica de asignación automática",
  "soda-b-homepage-i18n---首位必须是1，必须输入11位": "El primer dígito debe ser 1 y se deben ingresar 11 dígitos.",
  "FoodB_B86_UDxy_zyJV": "Esta tienda no tiene registros de irregularidades durante el periodo actual",
  "FoodOpB_CRM_Taxpayer_Tax_xOmZ": "N° del  contribuyente (Local)",
  "FoodC_202408_PvIX_VPCT": "Ingresa para ver ofertas y rastrear tu pedido",
  "FoodC_20240607_RSyh_XJnN": "Por favor, abre el enlace en tu dispositivo móvil",
  "Groceries_1_MhVY_Etfm": "Artículo cambiado",
  "FoodD_Name_August_cjQS": "Ago",
  "FoodB_0_SMS_yOMB": "Mensajes de texto",
  "FoodB_calculator_VFoE_zsGK": "Costo del artículo",
  "FoodC_payment_eCqh_ogxh": "Los pagos en línea aún no están disponibles. Te recomendamos seguir al pendiente.",
  "Gattaran_REGULAR_OPsx_JMnf": "Calcular",
  "FoodD_Name_February_bMVM": "Feb",
  "FoodC_202410_Ejdi_makf": "Elige una tienda",
  "FoodB_list_Name_of_dxYm": "Nombre del representante de ventas",
  "Gattaran_REGULAR_UodO_bJVP": "El valor no puede ser mayor a 100",
  "FoodB_V1_toMO_YDdz": "Tareas regulares",
  "FoodB_up20241218_VRuL_OZqJ": "Registro previo de la promo",
  "FoodB_0623_Indicators_auar": "KPI",
  "FoodC_202408_Jvou_Cqor": "Lugares cercanos",
  "FoodB_audit_The_strings_NPFx": "Hacer clic en confirmar iniciará el proceso de revisión \"{{strings}}\". No se puede solicitar la firma del contrato hasta completada la revisión. ¿Deseas continuar?",
  "Gattaran_REGULAR_JVAQ_pbxi": "Entrada básica",
  "FoodC_1_dXUH_ThDd": "Ver más",
  "Gattaran_V1__ZtqD": "Ver tutorial de promociones",
  "soda-c-i18n---送您1张%s优惠券；": "Te daremos un cupón de %s.",
  "FoodB_model20250116_GjAr_XZPC": "Hora de ingreso",
  "FoodB_Contract_QbrO_gJzi": "El premio de tarifa de servicio en el acuerdo es {{unit}} {{number}}%",
  "FoodB_APP_WsXR_yQpy": "Inversiones",
  "Gattaran_visit_CRcg_FwpW": "No",
  "FoodB_20250414_zXUI_rXee": "Premios de la tienda",
  "FoodB_APP_YjyK_hqYn": "Pedido",
  "FoodD_AccountInfoCollection_Got_it_QvNt": "Entendido",
  "FoodB_ads_yERH_XMYy": "¿Se ha registrado correctamente el anuncio promocional?",
  "FoodC_20240607_wWhy_deWR": "Por favor, actualiza la página y vuelve a intentarlo",
  "FoodB_governance_ireV_yxHO": "Fecha límite de la tarea",
  "FoodB_Optimization_QsfU_elzm": "Por favor, selecciona un tipo de tienda",
  "FoodC_optimization_GUGp_fDxe": "Volver",
  "FoodC_edit_oOAR_FExH": "Oficinas",
  "Gattaran_resivion_More_KTYU": "Más",
  "FoodC_202412_MrwA_fRUi": "En este momento, la tienda está cerrada. Por favor, regresa más tarde.",
  "FoodB_0707_Lifted_off_tnXl": "No disponible",
  "FoodB_Launch_DR_Temporary_BQFH": "Permiso residencia temporal",
  "FoodB_0830__BIGT": "Visitas en este mes",
  "FoodB_email_qdfP_heFs": "¡Hola! Visitamos tu tienda {{store_name}} y revisamos lo siguiente junto con {{person_to_be_visited}}:",
  "FoodB_calculator_AioF_coBc": "IVA sobre base gravable",
  "FoodB_time_No_permission_Xxyy": "Sin permisos",
  "FoodC_switch_TFwP_lxTd": "Propina predeterminada",
  "FoodB_0113_ZcCF_NbjE": "Puedes agregar un plan de visita aquí",
  "FoodB_up20241218_hGVF_hBSj": "Esta tienda no tiene artículos que cumplan con los requisitos. Sugerimos contactar a la tienda pronto para cargar los artículos.",
  "FoodB_0905__uatF": "Mayor que {{number_or_rate}} tiendas cercanas",
  "FoodC_remark_Thank_you_ENoY": "¡Gracias por elegir {{brand_name}}!",
  "FoodB_Show_Special_residence_ezfV": "Permiso Especial de Permanencia",
  "FoodC_dish_Leaving_LwWJ": "Salir",
  "FoodC_202408_ajMC_lsta": "Tienda cerrada",
  "FoodB_audit_Review_Opportunity_ZQHk": "Revisión de la información básica del socio potencial editada",
  "FoodB_CL_RUT_roUA": "RUT",
  "FoodB_Contract_ZLgE_qHzf": "Comparación con precios del competidor en el acuerdo",
  "FoodC_edit_wBJW_yfSo": "Apartamento",
  "FoodC_202408_RTrU_hOhN": "Por favor, activa los permisos de ubicación. Para hacerlo, ve a la configuración del sistema, selecciona la aplicación y activa los permisos de ubicación correspondientes.",
  "FoodC_202408_IfNx_VyNu": "Direcciones guardadas",
  "FoodC_dish_Current_activity_Iyrv": "Esta promoción termina en {{arrived_time}}. Las promociones para nuevos usuarios ya no estarán disponibles después de esa fecha",
  "FoodB_audit_Click_OK_Zfsf": "Si das en confirmar, se activará el",
  "FoodB_optimization_Full_reduction_NlOa": "Gasta X, Ahorra Y",
  "FoodC_dish_You_will_AXAT": "Sólo puedes disfrutar de promociones para nuevos usuarios en esta página.",
  "FoodB_20250414_uqsI_JhAj": "P1",
  "FoodB_email_mlcn_NvDS": "Método de contacto preferido",
  "FoodC_edit_NwrE_OHgM": "Encontrarse fuera del edificio de apartamentos",
  "FoodC_20240607_aOOB_RMKm": "Pago en efectivo no disponible temporalmente",
  "FoodB_data_End_mVwX": "Hora de cierre",
  "soda-c-i18n---晚间：%s-%s": "Durante la noche: %s a %s",
  "FoodB_2_Online_visit_OLuR": "Presencial",
  "FoodB_20250414_QcoH_HIDg": "Total de usuarios",
  "FoodC_page__iyoe": "Ver menos",
  "FoodB_0327_ZGTe_zcKH": "Pulsa aquí para cambiar de ciudad",
  "FoodB_0905__kaPI": "Calificación del diagnóstico",
  "FoodC_202410_YFVb_hzJK": "Agrega una dirección",
  "Gattaran_V1__WcTv": "Tasa de artículos calificados",
  "FoodB_model20250116_iVfy_zMbV": "Ingreso registrado con éxito",
  "soda-c-i18n---将赔付给您1张%s折扣券": "Obtienes un cupón del %s de descuento.",
  "Gattaran_visit_KjUG_kxHP": "El BD enlista los programas promocionales y revisa las necesidades de la tienda",
  "FoodB_0919__flip": "Artículos disponibles",
  "FoodB_0622_Sales_KRCg": "Volumen de ventas",
  "FoodC_education_1_If_iWDm": "1. Si no te es posible seguir las recomendaciones anteriores para recibir un pedido, podría considerarse que el inconveniente relacionado con la entrega fue tu responsabilidad. Esto incluye, pero no se limita a, situaciones en donde:",
  "FoodB_0617_Blon_MRMe": "Pedidos completados por día - Retiro en tienda",
  "soda-c-i18n---送您%s张免配送费券；": "Te daremos %s cupón para un envío gratis.",
  "FoodB_supplement_Network_connection_RVcl": "Falló la conexión. Comprueba tu configuración de red.",
  "FoodB_0617_lXTk_DfVL": "Fecha de vencimiento del contrato de exclusividad con la competencia - R",
  "FoodB_audit_Audit_process_asoS": "proceso de revisión. No podrás solicitar una firma hasta que se complete este proceso. ¿Estás seguro de que quieres continuar?",
  "FoodB_calculator_dsiQ_vhFJ": "Monto a recibir",
  "FoodB_tagging_You_chose_tIKm": "Decidiste invalidar este socio potencial por el siguiente motivo: \"La tienda no existe\". Para hacerlo, debes estar a menos de {{distance}} de la tienda. Verifícalo e inténtalo de nuevo.",
  "FoodB_20250612_nsLy_sirO": "Debes ingresar entre ocho y nueve dígitos",
  "FoodB_V2_No_legal_QONX": "Falta la identificación del representante legal",
  "FoodB_subsidy_xslH_mDaQ": "Este Acuerdo complementario para el premio de tarifa de servicio se firmará bajo el nombre de esta tienda. Actualmente, hay varias tiendas que ya han firmado bajo este nombre y que también recibirán premios de tarifa de servicio adicionales. ¿Quieres continuar con la firma?",
  "FoodC_202409_dTTH_bjFQ": "Este pedido se ha completado o no existe, por lo que no puede verse.",
  "FoodB_V1_tdXj_tAvG": "Tareas de la tienda",
  "FoodB_task_idjV_gpOC": "Tarea ejecutada",
  "FoodB_Commision_Type_of_EIWZ": "Tipo de tienda",
  "FoodC_202412_PwIG_QPFY": "Ingresa una dirección",
  "FoodB_Overview_AasD_LvfW": "Ver más",
  "Gattaran_visit_PQZP_gcOK": "Sí",
  "FoodB_NewStore_Status_HphC": "Estado",
  "FoodC_Website_At_present_XpFw": "En este momento no se puede canjear en la página web. Por favor, canjea el código promocional en la aplicación.",
  "FoodC_20240607_eLRx_hJRj": "Página no disponible en computadoras",
  "FoodB_list_Store_Phone_tSWo": "Número de teléfono de la tienda",
  "FoodC_edit_Hxmm_vrkU": "Edificio residencial",
  "FoodC_202408_PJcq_SjqG": "¡Ups! No hay información de contacto para esta tienda",
  "FoodB_202204_Number_of_yYUn": "Pedidos con calificación negativa",
  "Gattaran_visit_KNGQ_NwUQ": "El BD enlista los acuerdos anteriores",
  "FoodB_communications_mtxm_YcRA": "tiendas que no completaron las acciones para el impulso de tiendas nuevas",
  "FoodB_V1_zSAb_YlGe": "Queda(n) {{num_days_left}} día(s)",
  "FoodC_edit_bZFb_ghVG": "Encontrarse fuera del edificio del hotel",
  "FoodB_communications_ZlRD_aGjm": "día(s) faltante(s)",
  "FoodB_email_KYaO_tHVJ": "Operador de la app",
  "FoodB_Show_Savings_uvSS": "Cuenta de ahorros",
  "FoodB_0322_gUpY_CIHG": "No hay tiendas que coincidan con los filtros",
  "FoodB_Sales_NPeL_QUgG": "Ver menos",
  "FoodB_list_Apply_for_RxQn": "Solicitar firma",
  "FoodB_field_Is_you_uNye": "¿Sujeto al pago del IVA nacional?",
  "soda-c-i18n---延迟送达%s分钟以上": "Demora mayor a %s minutos",
  "FoodB_420241024_LTYv_GOfN": "Valor final",
  "FoodB_0617_UUYe_lgPA": "Porcentaje de tarifa de servicio de la competencia - R",
  "FoodB_optimization_Label_nzNw": "Etiqueta",
  "FoodB_leads_Artificial_labcategory_UNzu": "Categoría de etiqueta manual",
  "FoodD_supplement_Small_time_ycjv": "hora(s)",
  "FoodB_0617_JNlE_tpzR": "Porcentaje de tarifa de servicio de la competencia - U",
  "FoodB_P0_cNyW_HkyE": "Cambios en pedidos completados",
  "FoodC_edit_OVRs_CzUt": "Hotel",
  "FoodB_calculator_hPAw_BZlP": "Impuesto cedular",
  "FoodB_leads_The_relationship_jkYA": "Hora ideal para contactar",
  "FoodB_list_Store_ID_GNUR": "No. de identificación de la tienda",
  "FoodB_20230410_YNjt_xAWA": "Tienda DiDi Top",
  "FoodB_system_offline_revV": "Fuera de línea",
  "FoodC_202408_leda_oOpl": "Mejor control de pedidos",
  "FoodC_homepage_Search_for_CiMZ": "Buscar comida",
  "FoodB_0926__bEjZ": "No hay promociones iniciadas",
  "FoodB_model20250116_wlQy_yyEp": "Hora de la visita",
  "FoodB_CL_Individuals_VUHt": "Persona física",
  "FoodB_reason_Contact_Courier_Fqog": "Contactar al repartidor",
  "FoodD_suspensionpage_In_the_zGEU": "No hay más resultados",
  "FoodC_202408_AFKG_hWIj": "Fuera de rango. Favor de cambiar la dirección",
  "FoodB_V1_LADl_QUme": "Completar formulario",
  "FoodB_list_Setting_Up_YlBy": "set_open_duration",
  "FoodB_b_Source_of_qGPd": "Origen del evento",
  "FoodB_list_Brand_Name_pGTc": "Nombre de la marca",
  "FoodB_0_Please_upload_roTo": "Carga una captura de pantalla del historial de correo electrónico",
  "FoodC_perception_Tip_exceeds_VSFf": "La propina supera el límite",
  "FoodB_governance_Kygz_iFAW": "Rectificación por comparación de precios para comer en el local completada o no",
  "FoodB_email_NJBQ_LwUX": "Este contacto no tiene un correo electrónico registrado, por lo que no se le pueden enviar este tipo de mensajes. Por favor, agrega un correo electrónico y vuelve a seleccionarlo.",
  "FoodB_V2_Satisfied_with_YFEM": "Satisfecha con la situación actual",
  "FoodB_202202_Minutes_tWiN": "min",
  "FoodB_Translation_vrHE_fstW": "Rectificado",
  "sailing.d-api.common.页面获取失败，请稍后重试": "No se puede recuperar la página. Vuelve a intentarlo más tarde.",
  "FoodB_calculator_WFgZ_JmvX": "Calculadora de pagos",
  "FoodC_education_Principles_of_RKEk": "Recomendaciones en caso de algún inconveniente con la entrega",
  "soda-c-i18n---当前订单（不含已取消订单）未在预计送达时间内送达，%s将赔付给您一定金额的优惠券，订单完成后可以在": "Si un pedido no se entrega en el tiempo de entrega estimado (salvo los pedidos cancelados), %s te dará uno o más cupones para remediar las cosas. Una vez que se complete tu pedido, puedes ver los cupones en ",
  "FoodB_group0901_KjSA_JaMq": "Obligatorio",
  "FoodB_APP_PJrW_uBye": "AOP/ASP",
  "FoodB_email_AhaC_FOft": "Otro contacto",
  "Gattaran_visit_Zykg_WdpB": "El BD preparó la visita",
  "FoodC_202408_SXSA_LasS": "Agrega tu número de celular para más ventajas",
  "FoodB_requirement_aAaC_nmQK": "Horas pico en línea",
  "FoodB_up20241218_WbCj_pCMp": "Registro previo para la promoción de artículos en promoción de tienda nueva",
  "FoodB_I_Home_OrRo": "Inicio",
  "FoodB_tagging_You_chose_lWSH": "Decidiste invalidar este socio potencial por el siguiente motivo: \"No es una tienda de venta minorista\". Para hacerlo, debes estar a menos de {{distance}} de la tienda. Verifícalo e inténtalo de nuevo.",
  "FoodB_0905__qppX": "{{number}} pedidos menos que antes",
  "FoodC_202408_GeGr_xwdt": "Comunicación más sencilla",
  "FoodB_0617_tikP_Dusl": "Encuesta para la tienda",
  "FoodD_Name_September_Ezci": "Sep",
  "FoodD_Name_December_Ykas": "Dic",
  "Gattaran_REGULAR_bTIM_MAXe": "El valor no puede ser mayor a 1000",
  "FoodC_202408_xwYJ_IzdZ": "Continuar",
  "FoodB_20250612_ehqr_pgKz": "Gerente de tienda",
  "FoodB_model20250116_PRsL_yJEl": "Por favor, elige al menos {{num_required_fields}}",
  "FoodC_MVP_ASpO_MFfF": "Detalles del pedido",
  "FoodB_Translation_mIfp_fymE": "Resolver",
  "FoodB_calculator_QGtY_JOsw": "Inversión de la tienda sobre el descuento total",
  "FoodC_details_Refund_Details_sGIk": "Detalles del reembolso",
  "FoodB_0_Mail_SUKZ": "Correo electrónico",
  "FoodB_250430_GwJd_SQQB": "Nivel de la tienda",
  "FoodB_Translation_IfKE_iqmc": "Rectificación fallida",
  "FoodD_Compliance_About_to_fTcV": "Vence pronto",
  "FoodOpB_CRM_Taxpayer_Address_ptqR": "Dirección del  contribuyente (Local)",
  "FoodB_calculator_VujK_GJbV": "Utilidad",
  "FoodC_education_Basic_requirements_hIbv": "Recomendaciones para los usuarios con respecto a la entrega",
  "支付方式": "Payment Method",
  "FoodB_calculator_mTaD_pjZv": "Descuento total",
  "FoodD_Name_June_sECU": "Jun",
  "FoodB_APP_wyiJ_mGlw": "Mes de inicio",
  "FoodB_20250414_faym_bhsa": "Coinversión de la plataforma",
  "FoodB_Launch_Illegal_import_jlOS": "Entrada no válida",
  "FoodD_Name_November_BcWL": "Nov",
  "FoodB_GTR_MOcd_Ludv": "KA",
  "FoodC_1_mnqk_AcOb": "No se pudo copiar",
  "FoodB_calculator_tLev_cAgO": "Pago en línea",
  "FoodB_model20250116_dVSj_sFUN": "Esperando revisión",
  "FoodB_new1_Name_similarity_gepH": "Similitud del nombre",
  "FoodC_202408_sbmp_YFyl": "Ubicación actual",
  "FoodB_Wordings_MYHl_FXti": "Selecciona un motivo",
  "FoodC_202408_ZOBi_xjfW": "Buscar nombre del edificio/departamento",
  "FoodC_supplement_Modify_Mobile_ZJkT": "Para modificar tu número de teléfono o tu contraseña, agregar una dirección de correo electrónico o eliminar tu cuenta,",
  "FoodC_address_gNYi_HdzX": "No se pudo guardar",
  "FoodD_supplement_Rules_RYAa": "Reglas",
  "FoodB_email_qCka_NBMf": "Hora preferida para contactar",
  "FoodD_Incentive_In_progress_GNvs": "En curso",
  "FoodB_tagging_You_chose_DSiT": "Decidiste invalidar este socio potencial por el siguiente motivo: \"Operaciones detenidas\". Para hacerlo, debes cargar una foto o el número de contacto del representante de la tienda.",
  "FoodB_Optimization_xyJu_XgOc": "Por favor, ingresa 10 dígitos",
  "FoodB_2_Visit_Records_LiJy": "Resumen de visitas",
  "FoodC_edit_fLUx_wHAP": "Ejemplo: “llevo una camisa estampada.” También puedes subir fotos de los alrededores para ayudar al socio repartidor a entregar tu pedido en el lugar correcto.",
  "FoodD_problem_I_see_NhGG": "Aceptar",
  "FoodB_V1_DoLm_HYBb": "No comenzadas",
  "FoodB_optimization_Contract_No_GvBj": "Núm. de ident. del contrato",
  "FoodB_0919__YKYU": "Sin promociones",
  "FoodB_list_Online_Inspection_rExT": "Inspección de la tienda",
  "FoodB_calculator_mdtN_KpDW": "Descuento total",
  "FoodB_V1_FPpu_unON": "Cargar menú físico",
  "FoodB_202204_Order_eJXF": "Pedidos",
  "FoodC_202408_KYqe_yVZD": "Ahora no",
  "FoodB_250430_kaeY_cgas": "Nivel de visita",
  "FoodD_up_DiDi_Delivery_FdmM": "DiDi Repartidor",
  "FoodC_edit_kzdk_yzVc": "Encontrarse en la puerta de mi habitación",
  "FoodB_switch_yJQj_DSir": "Participando en promociones 100% financiadas",
  "FoodC_202408_pSzr_CJqz": "Guardar dirección",
  "FoodC_sales_Supplementary_information_ihyk": "Detalles adicionales",
  "FoodB_0919__RZJo": "Pedidos completados",
  "FoodB_Optimization_alYq_lLkr": "Foto de la entrada de la tienda del socio potencial",
  "FoodB_2_Planned_bPON": "Plan",
  "FoodC_202412_JiED_bPrx": "Sin resultados. Ingresa una calle y número válidos.",
  "FoodC_edit_HEFc_Dppo": "Encontrarse fuera de mi edificio residencial",
  "FoodB_Wordings_iyFv_fDmW": "Comentarios adicionales",
  "FoodB_20250414_EVlU_bloy": "Nuevos usuarios",
  "FoodB_store_Order_Coupon_zpSY": "Cupón de reembolso de pedido",
  "FoodC_web_Only_1_ZddK": "Sólo 1",
  "FoodC_1_ScPa_MVPN": "Copiado",
  "FoodB_APP_RDdB_KQgY": "Filtrar promociones de ventas",
  "FoodC_education_In_the_nIgD": "La cancelación se considerará responsabilidad tuya en las siguientes situaciones:",
  "Gattaran_visit_opSF_XPmM": "El BD trae objetivos claros a la visita",
  "Gattaran_REGULAR_ezuA_ZuBN": "Identificación fiscal",
  "FoodC_202412_SJdc_Bwta": "¿No es una ubicación cercana? Toca el botón de la derecha para actualizar tu ubicación.",
  "FoodC_dish_New_guest_bkGC": "Para primer pedido",
  "FoodC_202408_WiRK_SITI": "Agregar dirección",
  "soda-c-i18n---将赔付给您%s张免配送费券": "Obtienes %s cupón para un envío gratis.",
  "FoodC_all_You_haven_lSmt": "Aún no invitas a tus amigos. Intenta enviar una invitación.",
  "FoodB_calculator_Vzvw_WmgN": "Método de pago",
  "FoodB_calculator_rMFF_EMXI": "Efectivo",
  "FoodC_202408_IDjR_CbbT": "Aceptar",
  "FoodD_accept_vrSy_OJYX": "Aceptación automática",
  "FoodB_GTR_rBBn_RmKL": "Estándar",
  "FoodC_education__2_KHhl": "(2) Si no llegaste al lugar de la entrega para la hora especificada o si ingresaste la dirección o número de teléfono incorrectos, te negaste a aceptar una llamada del socio repartidor o te negaste a recibir parte del pedido o el pedido completo sin un motivo válido, se deberá pagar el pedido.",
  "FoodB_2_Call_visit_NGFu": "Teléfono",
  "FoodB_I_Cancelled_orders_XeVk": "Pedidos cancelados",
  "FoodB_Translation_IcyT_qdIf": "A rectificar",
  "FoodB_calculator_giVW_AULQ": "Precio unitario de la plataforma",
  "FoodC_education_If_you_RTIV": "Si pagaste un pedido y necesitas cancelarlo, se aplicará lo siguiente:",
  "FoodC_education_2_Receiving_gFZl": "2. Revisa que la dirección de entrega y el método de contacto que proporciones sean los correctos.",
  "FoodB_1__GxZN": "Últimos 30 días",
  "FoodB_calculator_EeIc_TwiG": "Persona moral",
  "FoodB_B86_xxgH_gxNC": "Incorrecta",
  "FoodB_20250414_WmJY_oZbB": "Gráfico de embudo",
  "FoodD_Name_March_cqIc": "Mar",
  "FoodB_optimization_Stimulate_contact_xSSH": "Método de contacto preferido",
  "FoodC_202412_AIDx_XZgz": "Editar dirección",
  "FoodB_calculator_HfHr_bkLf": "Subsidio de DiDi sobre el descuento total",
  "FoodC_education__3_TDsa": "(3) Te negaste a recibir el pedido, ya sea una parte del mismo o por completo",
  "FoodB_B86_xkRX_bJPm": "¿Es precisa la información sobre las irregularidades?",
  "FoodB_Launch_DR_ID_AnVk": "Cédula Dominicana",
  "FoodC_education_2_If_SoSk": "2. Si un inconveniente relacionado con una entrega sucede porque el socio repartidor no siguió las recomendaciones, se podría considerar que fue responsabilidad del socio repartidor.",
  "FoodB_CL_Vista_Account_QcOm": "Cuenta Vista",
  "FoodB_B86_Kypx_nBHu": "Notas",
  "FoodC_education__unk_aOCD": "Recomendaciones de la aplicación sobre el tipo de entrega:  {{delivery_type}}",
  "FoodB_0919__mVqa": "Demoras en la entrega",
  "FoodB_I_onwf_oaQH": "Ventas",
  "soda-c-i18n---订单实际送达时间晚于预计送达时间%s分钟以上，": "Si tu pedido llega %s minutos después del tiempo de entrega estimado,",
  "soda-c-i18n---取消订单": "Cancelar pedido",
  "请选择支付方式": "Selecciona un método de pago",
  "FoodB_calculator_UUgW_xBLd": "Cantidad de artículos",
  "小费": "Propina voluntaria",
  "Gattaran_V1__ccGl": "Últimos 30 días",
  "FoodB_Part1_Store_Name_jrHD": "Nombre del restaurante",
  "FoodC_cash_WQNI_uYzC": "Agregar",
  "FoodB_progress_ZdQT_mHfK": "Restablecer",
  "sailing.crm-intl.普通": "General",
  "FoodB_calculator_Jryi_aded": "Personería fiscal",
  "FoodB_420241024_FldG_feZL": "Valor objetivo",
  "FoodC_education__2_jwSo": "(2) Dejar en la puerta (con nota)",
  "FoodB_0919__CONM": "Artículos no disponibles",
  "FoodD_page_Manual_Accept_jCTW": "Aceptación manual",
  "FoodB_Contract_tFOZ_SiQZ": "¿Te registraste correctamente para la promoción?",
  "FoodB_0_Please_upload_dcPG": "Carga una captura de pantalla del historial de mensajes de texto",
  "FoodB_GTR_nRcI_TMWR": "CKA",
  "FoodB_Show_Subject_Information_RFOj": "Información del Representante Legal/Propietario",
  "FoodC_dish_Are_you_TaUN": "¿Salir de la página de la promoción?",
  "FoodB_CL_Add_any_egRn": "Es aceptable cualquiera de los siguientes tres documentos:\nPoder del Representante Legal\nCertificado de Comercio de Registro de Santiago (o ciudad respectiva)\nCertificado de Estatuto Actualizado",
  "FoodB_Show_Company_Registration_VcVV": "Cédula Jurídica",
  "FoodB_Contract_BRLH_nPAs": "¿Se completó la primera conexión?",
  "FoodB_20250612_jtyZ_DrEC": "Amigo/familiar del propietario de la tienda",
  "FoodB_0617_Cgpc_KwbS": "Por favor, ingresa un valor con dos decimales",
  "FoodB_V1_GLnG_kpoL": "Tareas del proyecto",
  "FoodB_0920__QnBO": "Requisitos no cumplidos",
  "FoodB_Contract_ywoA_Ojgz": "No",
  "FoodB_0617_rPjX_pvuu": "¿El restaurante recibe pedidos por WhatsApp o teléfono?",
  "FoodB_model2025011603_ztWt_rarX": "Por favor, selecciona primero el método de visita y el tipo de visita",
  "FoodB_Commision_Cancel_wbtQ": "Cancelar",
  "FoodB_resivion_Skip_qpSD": "Omitir",
  "FoodC_education_4_Customers_laxR": "4. Una vez que el socio repartidor llegue a tu ubicación, tendrás 10 minutos para recibir tu pedido.",
  "FoodB_model20250116_IADF_eXfa": "Hora de salida",
  "FoodOpB_Management_You_can_aDLi": "Para crear la tienda nueva de todos modos, haz clic en “solicitar revisión”. Ten en cuenta que la revisión puede tomar hasta 2 días.",
  "FoodC_202408_cktm_HTVV": "Entendido",
  "FoodC_shop__MWyO": "Límite de compra: {{num}}",
  "FoodOpB_CRM_Card_holder_NfIL": "Ingresa el número de identificación del beneficiario",
  "FoodB_Translation_ycvD_ntAQ": "Apelación",
  "FoodC_202412_aCvV_UNyj": "Agregar nueva dirección",
  "FoodB_20250414_qQjO_NTiY": "Línea de tiempo",
  "FoodB_Translation_CHLm_cImn": "Motivo de la apelación",
  "FoodB_email_Lqnd_eyfn": "Acuerdos y comentarios",
  "FoodC_2022__SEQk": "Propina",
  "FoodB_0622_The_statistical_NUCJ": "Los datos se calculan con base en T+1 y se organizan de acuerdo al volumen de ventas de los artículos en los últimos 30 días",
  "FoodB_20250414_BqXP_FPkP": "Tasa de recompra",
  "FoodB_0830__wEQD": "Pedidos completados en este mes",
  "FoodC_202410_SiDC_Empm": "Pedir",
  "优惠券": "Cupón",
  "FoodC_202410_OFhs_UnlA": "Explorar",
  "FoodB_250430_YTkG_lNTj": "Nivel de la marca",
  "FoodB_I_UlHM_KKLT": "Pedidos",
  "FoodC_optimization_RLDn_cLAQ": "Agregar dirección de entrega",
  "FoodC_optimization_hksX_yevn": "Agrega la dirección donde se entregará tu pedido.",
  "FoodB_calculator_cctL_sltb": "Total del pedido",
  "soda-c-i18n---订单实际送达时间晚于预计送达时间%s分钟以上、%s分钟以下，": "Si tu pedido llega entre %s y %s minutos después del tiempo de entrega estimado, ",
  "FoodB_APP_QiyP_UysU": "ASP",
  "FoodB_0921__iLXg": "Cantidad",
  "FoodB_Show_Aliens_Residence_creU": "Cédula de Residencia",
  "FoodC_sales_Condition_of_lnwg": "¿Estaba sellado el empaque? (Obligatorio)",
  "soda-c-i18n---送您1张%s折扣券；": "Te daremos un cupón del %s de descuento.",
  "FoodB_0919__etPs": "Múltiples promociones",
  "分钟": "min",
  "FoodB_email_WcaT_rLqN": "El resultado de la visita está incompleto. Por favor, ingresa el resultado de la visita antes de continuar con la optimización.",
  "FoodC_edit_EqUG_FRvo": "Apto./Piso/Habitación",
  "FoodB_communications_udno_SENU": "Hay una o más promociones pendientes de aceptación. Participar en las promociones podría ayudar a impulsar las ventas.",
  "FoodB_calculator_lSyU_ySZI": "¿La tienda está ubicada en Guanajuato?",
  "FoodB_email_FvUP_tJQT": "Nombre",
  "FoodC_202412_SxTA_sqKU": "Ubicación cercana",
  "FoodB_CL_Letter_of_EmKs": "Foto del Contrato de Mandato",
  "FoodB_202207_Default_BQmA": "Predeterminado",
  "FoodB_0113_ELbg_zfBg": "Ver info. sobre el asesor de la tienda aquí",
  "FoodB_Analysis_Old_people_fwCy": "Usuarios recurrentes",
  "FoodB_0905__wwdP": "Peso de subartículo",
  "FoodC_popup_After_closing_ujoW": "Si sales, no se guardarán los platos seleccionados",
  "FoodC_edit_ldOR_SyHv": "Ejemplo: “llevo una camisa estampada y estoy esperando en la calle.” También puedes subir fotos de los alrededores para ayudar al socio repartidor a entregar tu pedido en el lugar correcto.",
  "Gattaran_REGULAR_luKX_QwKw": "Entrada de impuesto de México",
  "FoodB_0905__ccXH": "Periodo del diagnóstico",
  "FoodC_remark_Enjoy_your_OvmD": "¡Que disfrutes tu comida!",
  "FoodC_improve__ByLg": "Diferente a lo esperado",
  "FoodB_V2_DQvR_Redp": "Usa la función para compartir en la app de BD.",
  "FoodC_optimization_knQx_VpIr": "Agregar",
  "soda-c-i18n---超时赔付规则说明": "Cupón por entrega demorada",
  "FoodB_up20241218_dJSA_yyZX": "Confirmar",
  "FoodC_education__1_IIfh": "(1) Si cancelaste antes de que la tienda haya aceptado el pedido con la función \"Cancelar pedido\" en la sección de Detalles del pedido.",
  "FoodB_Translation_wHEO_FLQr": "Apelación exitosa",
  "FoodB_0905__vMsv": "{{number}} pedidos más que antes",
  "GDriver_trans_seconds_fFsz": "segundos",
  "FoodB_I_QuSz_HsAZ": "Descuento de promo %",
  "支付": "Pagar",
  "FoodC_reasons_Enter_a_Pnzg": "Por favor, describe los detalles del problema.",
  "Gattaran_REGULAR_KZHa_qJOa": "Ingresa un número entero",
  "FoodB_Contract_cBzR_gTDZ": "¿El acuerdo incluye comparación con precios de competidores?",
  "FoodB_IV_Tips_DFOG": "Alerta",
  "FoodB_audit_The_information_jxLV": "La información que enviaste no cumple con los requisitos",
  "FoodD_messagemanagement_Mail_UMqH": "Correo electrónico",
  "FoodC_Notification_ZawA_BoKt": "Ver pedidos en curso",
  "FoodB_420241024_TFhQ_lSww": "Se rechazó correctamente",
  "FoodB_optimizing_Duplicate_Store_aBYS": "Número de identificación de restaurante duplicado",
  "FoodB_V1_Yqgj_TuBe": "Vencidas",
  "FoodB_model20250116_pAHl_Vjqs": "No aprobada",
  "FoodB_calculator_hmWL_DEwB": "No",
  "FoodC_20240607_IbZr_cIyA": "Por favor, revisa el enlace de la tienda y vuelve a intentarlo",
  "FoodB_0617_Bibj_VmDq": "Plataformas de la competencia",
  "FoodC_202412_Afcx_fMwc": "Seleccionar dirección",
  "FoodB_Upload_qSTm_LkAc": "Menú para consumo en el lugar",
  "FoodC_education__4_QYXm": "(4) Te negaste a pagar el pedido con pago en efectivo",
  "FoodB_APP_eiHc_XFQQ": "Porcentajes de promoción",
  "FoodB_V2_No_bank_plEI": "Faltan los datos bancarios",
  "FoodB_Show_Final_Tax_XQQi": "Definitivo",
  "FoodB_V2_No_store_ahBo": "Falta RFC (Registro Federal de Contribuyentes) *only mx",
  "FoodC_education_In_the_MKeB": "La cancelación no se considerará responsabilidad tuya en las siguientes situaciones:",
  "FoodB_0617_pPbU_koUF": "Hay un contrato de exclusividad con la competencia - U",
  "FoodC_education__3_ltNM": "(3) Otros factores que no puedas controlar y que causaron la cancelación del pedido, como que no se haya podido encontrar un socio repartidor que entregue el pedido o algún otro asunto.",
  "FoodC_202412_QwDD_sIOi": "Fuera de la zona de entrega",
  "FoodB_subsidy_czaK_LuDh": "La aplicación de Asesor no admite la firma de contratos para este tipo de tienda. Acude a GTR para firmar el contrato.",
  "FoodB_tagging_You_have_ssrJ": "Decidiste invalidar este socio potencial por el siguiente motivo: \"No es una tienda de venta minorista\". Para hacerlo, debes cargar una foto o el número de contacto del representante de la tienda.",
  "FoodB_model20250116_QHad_xAWm": "Tipo de visita",
  "FoodC_improve__ovBF": "Porciones pequeñas",
  "FoodB_V1_vKqg_VkFI": "Lista de proyectos",
  "FoodB_up20241218_ZADd_MrpU": "Por favor, selecciona entre uno y cinco artículos. No pueden seleccionarse artículos o bebidas con alcohol.",
  "FoodB_email_SHyg_fIzy": "Falta el correo electrónico. Por favor, agrégalo para enviar el correo electrónico",
  "FoodC_202412_enwa_nWfu": "Este artículo está agotado. Puedes explorar otros artículos de la tienda.",
  "FoodB_0617_RqaF_EHZE": "Fecha de vencimiento del contrato de exclusividad con la competencia - U",
  "FoodOpB_CRM_Type_of_fbmW": "Tipo de identificación del beneficiario",
  "FoodB_audit_New_and_yYux": "Diferencia entre el nombre anterior de la tienda y el nuevo",
  "FoodB_20250414_pQls_dkIZ": "Usuarios recurrentes",
  "FoodB_Contract_YYIE_YBzS": "Sí",
  "FoodB_V2_Failure_to_sQaD": "No cumple con los requisitos",
  "FoodC_edit_fOqC_upyr": "Encontrarse en la recepción",
  "FoodC_202410_UazG_LTwS": "No hay tiendas disponibles",
  "FoodB_20250612_vHLr_wHDi": "Número de WhatsApp",
  "FoodB_Show_Tax_payment_Dbuz": "Forma de pago de impuestos (Local)",
  "FoodC_202410_KMCG_kJBn": "Cambiar",
  "FoodB_calculator_pQIn_LdhF": "¿La identificación fiscal es válida?",
  "FoodB_governance_coYD_UvmL": "Rectificación en línea multiplataforma completada o no",
  "FoodC_202410_hAya_NcZF": "Confirmar ({{countdown}} s)",
  "FoodC_all_No_reward_ocGJ": "Sin premios",
  "FoodB_0622_Contrast_jVys": "Comparar",
  "FoodC_education_In_order_AZCw": "Las recomendaciones para la entrega se crearon con el motivo de ayudar a que todos los usuarios tengan una buena experiencia con {{brand_name}}. En caso de que haya algún inconveniente relacionado con la entrega, se aplicará lo siguiente.",
  "FoodB_Show_Special_Tax_Eidl": "NITE (Número de Identificación Tributaria Especial)",
  "FoodB_Contract_rrZL_POpC": "El precio de {{brand_name}} es {{unit}} {{number}} % del precio para consumo en el lugar",
  "FoodC_edit_KDUB_nVRR": "obligatorio",
  "FoodB_Contract_adlR_lBNU": "¿Se cargó correctamente el menú para comer en el lugar aprobado?",
  "FoodOpB_CRM_Taxpayer_full_tMpR": "Nombre completo del contribuyente (Local)",
  "FoodC_education__2_KZTZ": "(2) El socio repartidor no pudo contactarte",
  "FoodB_communications_BCnM_evHy": "tiendas que tienen acciones a realizar esta semana para el impulso de tiendas nuevas",
  "FoodB_leads_KP_Phone_hCUe": "Teléfono 2 del representante del restaurante",
  "FoodB_Contract_PpIv_FHlg": "¿El acuerdo incluye premio de tarifa de servicio?",
  "FoodB_Wordings_DKwT_wbfI": "Indica por qué elegiste esta opción. Tus comentarios son valiosos y nos ayudan a mejorar.",
  "FoodB_new1_Similarity_ItET": "Similitud",
  "Gattaran_visit_jnPQ_METw": "¿La persona que toma decisiones estuvo presente en la visita?",
  "FoodB_V2_iZpC_KKcK": "Compartir reporte de diagnóstico con la tienda",
  "FoodB_supplement_No_data_jUGB": "Sin datos",
  "FoodB_Contract_fYLE_mfir": "Actualizar información de encuesta para la tienda",
  "soda-c-i18n---联系商家": "Comunícate con la tienda.",
  "FoodC_20240607_qihL_obWb": "No se encontró la tienda",
  "FoodB_0921__kEaD": "Subsidio%",
  "FoodC_education_Cancellation_Policy_fxrl": "Política de cancelación",
  "FoodC_202409_rOOL_Peyp": "Ingresar número de celular",
  "FoodB_email_Cebi_VpDl": "Teléfono",
  "FoodB_Analysis_New_customers_vYDl": "Usuarios nuevos",
  "FoodB_up250108_UapS_ZXgM": "Ver ahora",
  "FoodB_email_Zgsh_mNSy": "KP",
  "FoodB_optimization_Special_Meal_YtqD": "Artículos en promoción",
  "FoodB_V1_pmrO_ZtzK": "Completada",
  "FoodC_edit_cKhP_xcTQ": "Encontrarse en la puerta de mi vivienda",
  "FoodC_20240607_hfCf_kdpO": "Teléfono",
  "FoodB_resivion_Overdue_visit_jTHW": "Visitas vencidas",
  "FoodB_calculator_TJJY_SkoH": "Inversión de la tienda",
  "FoodOpB_CRM_Taxpayer_Address_EBwy": "Dirección del contribuyente (Nacional)",
  "FoodC_202408_YjqN_Yvyz": "Agrega una dirección para ver tarifa y tiempo",
  "FoodC_202410_FxEp_LCxL": "Procesando pago",
  "Groceries_web__Ovnh": "¡Lo sentimos! Por el momento sólo se puede acceder a las tiendas en la aplicación móvil.",
  "FoodC_edit_DOXu_EYnd": "Ejemplo: “llamar a la puerta, no tocar el timbre.” También puedes subir fotos de los alrededores para ayudar al socio repartidor a entregar tu pedido en el lugar correcto.",
  "FoodB_IGV_WGYF_kfvV": "IGV",
  "FoodD_Name_July_RJXL": "Jul",
  "FoodB_email_Bwgs_muyN": "Empleado",
  "FoodC_202408_IMjl_ywFc": "Cambiar",
  "Gattaran_V1__SttS": "Promociones",
  "FoodC_202410_pHYX_VjbD": "Cerrar",
  "FoodB_model20250116_TRTm_agBI": "Volver",
  "FoodB_calculator_ydSg_ejbp": "IVA",
  "FoodB_2__FNaI": "La misma zona objetivo"
}